import { VariantProps, cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

export interface FlockProps extends VariantProps<typeof FlockStyles> {
    className?: string;
}

export const FlockStyles = cva("-z-1 absolute translate-x-[-100%]");

export const Flock = ({ className }: FlockProps): JSX.Element => {
    return (
        <img
            alt="flock"
            className={twMerge(FlockStyles({ className }))}
            src="/assets/beat/flock/flock.svg"
        />
    );
};
